import { Field, Item, RichText, Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import React from 'react';

import type { ComponentProps } from 'lib/component-props';
import withStyles from 'lib/enhancers/withStyles';

import styles from './AnnouncementDetail.module.scss';
import RichTextWrapper from 'components/helpers/RichText/RichTextWrapper';
import { getEffectiveMonthandYear } from 'lib/utils';
import { sitecoreMediaInRichText } from 'lib/sitecoreMedia';

type AnnouncementDetailFields = {
  announcementTitle: Field<string>;
  effectiveDate: Field<string>;
  labels: Item[];
  announcementBody: Field<string>;
};

type AnnouncementDetailProps = ComponentProps & {
  fields: AnnouncementDetailFields;
};

const cx = classNames.bind(styles);

const AnnouncementDetail = (props: AnnouncementDetailProps): React.JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const { className, fields } = props;
  let effectiveMonthAbbr = '';
  let effectiveYear = null;
  const effectiveDateString = fields?.effectiveDate?.value;

  if (effectiveDateString != '0001-01-01T00:00:00Z') {
    const effectiveMonthandYear = getEffectiveMonthandYear(effectiveDateString);
    effectiveMonthAbbr = effectiveMonthandYear.month;
    effectiveYear = effectiveMonthandYear.year;
  }

  const announcementBodyField: Field<string> = {
    ...fields.announcementBody,
    value: sitecoreMediaInRichText(fields.announcementBody?.value) ?? fields.announcementBody?.value,
  };
  const AnnouncementBodyComponent = sitecoreContext.pageEditing ? RichText : RichTextWrapper;
  const announcementBodyDisplayField = sitecoreContext.pageEditing ? fields?.announcementBody : announcementBodyField;

  return (
    <div className={cx('announcement-detail', 'component-container-edge', className)}>
      <h1 className="font-style-2xl mb-0">
        <Text field={fields?.announcementTitle} encode={sitecoreContext.pageEditing} editable={true} />
      </h1>
      <div className={cx('announcement-date-label')}>
        {props.fields?.effectiveDate?.value != '0001-01-01T00:00:00Z' && (
          <strong>
            {effectiveMonthAbbr} {effectiveYear}
          </strong>
        )}
        {props.fields?.labels?.map((labelItem, index) => (
          <span key={index}>
            <Text field={labelItem.fields?.Value as Field<string>} editable={false} />
          </span>
        ))}
      </div>
      <AnnouncementBodyComponent field={announcementBodyDisplayField} className={cx('body')} editable={true} />
      <hr />
    </div>
  );
};

export default withStyles()<AnnouncementDetailProps>(AnnouncementDetail);
